import {
  Text,
  VStack,
  FormControl,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import { setAdditionalBrokerNote } from 'reducers/lifeInsuranceFormReducer';
import LifeAdditionalFileUpload from '../LifeAdditionalFileUpload';

interface LifeAdditionalDocumentsAndNotesProps {
  isLocked?: boolean;
}

const LifeAdditionalDocumentsAndNotes = ({
  isLocked = false,
}: LifeAdditionalDocumentsAndNotesProps) => {
  const dispatch = useAppDispatch();

  const additionalBrokerNote = useAppSelector(
    (state) => state.lifeInsuranceForm.data.additional_broker_note || '',
  );

  const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setAdditionalBrokerNote(event.target.value));
  };

  return (
    <>
      <LifeAdditionalFileUpload isLocked={isLocked} />

      <Card mb="20px" id="sectionLifeAdditionalDocumentsAndNotes">
        <Text fontWeight="bold" fontSize="2xl" mb="20px">
          Additional Broker Notes
        </Text>

        <VStack spacing={4} align="stretch">
          <FormControl>
            <FormLabel ml="0">Notes</FormLabel>
            <Textarea
              value={additionalBrokerNote}
              onChange={handleNoteChange}
              placeholder="Enter any additional notes..."
              rows={4}
              isDisabled={isLocked}
            />
          </FormControl>
        </VStack>
      </Card>
    </>
  );
};

export default LifeAdditionalDocumentsAndNotes;
